import { FC } from "react";
import { FullHeightContainer } from "../../Common/views/FullHeightContainer";
import { HeaderConfig } from "../../Header/views/HeaderConfig";
import { useSelectedOrganization } from "../../Organizations/hooks/useSelectedOrganization";
import { OrganizationNotFoundView } from "../../Organizations/views/OrganizationNotFoundView";
import { TendersEndedView } from "./TendersEndedView";
import { TendersSetupView } from "./TendersSetupView";

export const TendersEndedPage: FC = () => {
  const organizationId = useSelectedOrganization(
    (organization) => organization?.id,
  );
  const isOrganizationTypeClient = useSelectedOrganization(
    (organization) => organization?.types?.includes("CLIENT"),
  );

  return (
    <>
      <HeaderConfig variant="WITH_NAVIGATION" />
      <FullHeightContainer>
        {organizationId ? (
          isOrganizationTypeClient ? (
            <TendersEndedView organizationId={organizationId} />
          ) : (
            <TendersSetupView />
          )
        ) : (
          <OrganizationNotFoundView />
        )}
      </FullHeightContainer>
    </>
  );
};
